import { createTheme } from "@mui/material/styles";

// --black: #000000ff;
// --ghost-white: #F8FAFEff;
// --white: #FFFFFFff;
// --space-cadet: #12183Bff;
// --space-cadet-2: #1E2445ff;
// main: "#42b5e6",
// main: "#6750a4",

// site fynd.com.br
// #48a2ad

const theme = createTheme({
  palette: {
    common: {
      black: "#141414",
      white: "#ffffff",
    },
    text: {
      primary: "#141414",
    },
    primary: {
      dark: "#252d51",
      main: "#2f3d6a",
      light: "#44578D",
      contrastText: "#ffffff",
    },
    secondary: {
      dark: "#335555",
      main: "#3d787e",
      light: "#428c95",
      contrastText: "#ffffff",
    },
  },
});

export default theme;
